import React from 'react';

const Footer = () => (
  <footer className="w-full bg-gray-100 has-text-centered text-gray-600 py-4 text-sm">
    © {new Date().getFullYear()} Contributed by Yiwen Wu
  </footer>
);

export default Footer;
